export default "__VITE_ASSET__5d928107__"